/* eslint-disable */
import { FlowManagerService } from './flowmanager.service';
import { ApplicationProxyService } from './applicationproxy.service';

export class PlaidService {

  constructor(flowManager: FlowManagerService, appProxy: ApplicationProxyService) {
    this.flowManager = flowManager;
    this.appProxy = appProxy;

    this._onEvent = () => {};
    this._onExit = () => {};
    this._onLoad = () => {};
    this._onSuccess = () => {};

    this._initPlaid();
  }

  async _initPlaid() {
    const plaidConfig = this.flowManager.config.plaidClient;
    const { link_token } = await this.appProxy.getLinkToken();
    const handler = Plaid.create({
      token: link_token,
      apiVersion: plaidConfig.plaidApiVersion,
      clientName: plaidConfig.plaidClientName,
      env: plaidConfig.env,
      product: ['identity', 'auth'],
      selectAccount: true,
      onSuccess: (publicToken, metadata) => { this._onSuccess(publicToken, metadata); },
      onLoad: (err, metadata) => { this._onLoad(err, metadata); },
      onExit: (err, metadata) => { this._onExit(err, metadata); },
      onEvent: (eventName, metadata) => { this._onEvent(eventName, metadata); }
    });
    this.handler = handler;

  }

  open() {
    if (this.handler) {
      this.handler.open();
    }
  }

  close() {
    if (this.handler) {
      this.handler.exit({ force: true });
    }
  }

  onSuccess(cb) { this._onSuccess = cb; }

  onLoad(cb) { this._onLoad = cb; }

  onExit(cb) { this._onExit = cb; }

  onEvent(cb) { this._onEvent = cb; }
}